import React, { ReactNode } from 'react'

import styles from './index.module.css'

interface IActionProps {
  children: ReactNode
}

export const Action = (props: IActionProps) => {
  const { children } = props

  return <div className={styles.container}>{children}</div>
}

Action.displayName = 'Card.Action'
